<script>
import classModifierMixin from './mixins/class-modifier-mixin'
export default {
	name: 'BaseLoading',
	props: {
		loading: {
			type: Boolean,
			default: false
		}
	},
	mixins: [classModifierMixin]
}
</script>

<template>
	<div class="base-loading">
		<slot></slot>
		<div class="base-loading__overlay" v-show="loading" :class="modifierClasses">
			<font-awesome-icon class="base-loading__spinner" :icon="['fas', 'spinner']" spin />
		</div>
	</div>
</template>

<style lang="scss">
	.base-loading {
		position: relative;
		&--large-spinner {
			font-size: 10rem;
			@media (max-width: 500px) {
				font-size: 7rem;
			}
		}
		&--medium-spinner {
			font-size: 5rem;
			min-height: 5rem;
		}
		&--light-overlay {
			background-color: white;
			opacity: 0.4;
			color: #575757;
		}
		&--dark-overlay {
			background-color: black;
			opacity: 0.4;
			color: #E4E4E4;
		}
		&--light-opacity {
			opacity: 0.2;
		}
		&__overlay {
			position: absolute;
			top: 0;
			height: 100%;
			width: 100%;
			z-index: 10;
			display: flex;
			justify-content: center;
			align-items: center;
			transition: .5s ease;
		}
		&__spinner {
			transition: .5s ease;
			opacity: 0.8;
		}
	}
</style>
